import { Link } from 'react-router-dom';
import logo from '../assets/schoolloga.jpeg';
import './Navbar.css';

function Navbar() {
  return (
    <nav className="navbar">
      <div className="logo">
        <img src={logo} alt="Schoolloga" style={{
          height: '50px',
          width: '50px',
          borderRadius: '50%',
          objectFit: 'cover',
          marginRight: '10px',
          verticalAlign: 'middle'
        }} />
        Srilakshmi Matric High School
      </div>
      <ul className="nav-links">
        <li><Link to="/">Home</Link></li>
        <li><Link to="/about">About</Link></li>
        <li><Link to="/admissions">Admissions</Link></li>
        <li><Link to="/gallery">Gallery</Link></li>
        <li>
          <Link to="/contact" style={{
            background: 'white',
            color: '#1a6b3c',
            padding: '8px 18px',
            borderRadius: '20px',
            fontWeight: 'bold'
          }}>Contact Us</Link>
        </li>
      </ul>
    </nav>
  );
}

export default Navbar;